<script>
    import { onMount } from "svelte";
    import { isObjectEmpty } from "../../../Utils/utilFunctions.svelte";
    import { _getDisplayDate } from "../../PatientEncounter/helpers/encounterHelper.svelte";
    import { loadEventMetadata } from "../helpers/calendarHelper.svelte";
    import CustomTooltip from "../../../Components/Common/CustomTooltip.svelte";

    export let event;

    let eventMetadata = {};
    
    onMount(() => {
        try {
            loadEventMetadata(event).then((res) => {
                eventMetadata = res;
            })
        }
        catch(e) {
            console.log("Error getting event metadata", e)
        }
    });

</script> 

{#if !isObjectEmpty(eventMetadata)}
    <CustomTooltip 
        zIndex={99999}
        contentClass="max-h-60 overflow-y-auto overflow-x-hidden min-w-0"
        tooltipPosition="left">
        <div class="cursor-pointer pt-1 pr-1" slot="tooltipTrigger">
            <i
                class="fa-solid fa-circle-info"
            >
            </i>
        </div>
    
        <p class="m-0 break-words [overflow-wrap:anywhere] hyphens-auto">
            <span class="text-sm normal-case">
                {#if eventMetadata.createdOn}
                    <p>Created: <b>{_getDisplayDate(eventMetadata.createdOn)} {eventMetadata.createdBy}</b></p>
                {/if}
                {#if eventMetadata.updatedOn}
                    <p>Updated: <b>{_getDisplayDate(eventMetadata.updatedOn)} {eventMetadata.updatedBy}</b></p>
                {/if}
            </span>
        </p>
    </CustomTooltip>
    
{/if}